module.exports = "img/flags/LS.39647ea.png";